import { render, staticRenderFns } from "./maintainanceItemList.vue?vue&type=template&id=6108130f&scoped=true"
import script from "./maintainanceItemList.vue?vue&type=script&lang=js"
export * from "./maintainanceItemList.vue?vue&type=script&lang=js"
import style0 from "./maintainanceItemList.vue?vue&type=style&index=0&id=6108130f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6108130f",
  null
  
)

export default component.exports